import { render, staticRenderFns } from "./ModalOtherIncomeEdit.vue?vue&type=template&id=68d5d672&"
import script from "./ModalOtherIncomeEdit.vue?vue&type=script&lang=js&"
export * from "./ModalOtherIncomeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports